import React, { useState } from 'react';
import { AgGridReact } from "ag-grid-react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { useTranslation } from "react-i18next";
import * as Colors from '../../../../constants/Colors';
import PerformanceChart from './PerformanceChart'
import HeaderTitle from '../../CopyPeopleList/HeaderTitle'

function Performance(props) {
    const { i18n } = useTranslation();
    const rowHeight = 50;
    const defaultColDef = {
        flex: 1,
        minWidth: 10,
        sortable: true,
        resizable: true,
        cellStyle: { textAlign: i18n.language === "ar" ? "right" : "left", lineHeight: '2.5' },
        // headerClass: "center-header"
    };
    const ColorsgreenNumber = props.isDarkMode ? Colors.greenNumberDarkTheme : Colors.greenNumber;

    const [rowSelected, setRowSelected] = useState([])
    const [rowData, setRowData] = useState([
        {
            Year: '2024',
            JAN: '0.11',
            FEB: '',
            MAR: '',
            APR: '',
            MAY: '',
            JUN: '',
            JUL: '',
            AUG: '',
            SEP: '',
            OCT: '',
            NOV: '',
            DEC: '',
            TOTAL: "0.11"
        },
        {
            Year: '2023',
            JAN: '1.06',
            FEB: '-2.05',
            MAR: '1.34',
            APR: "-5.09",
            MAY: "-1.94",
            JUN: "5.53",
            JUL: '5.94 ',
            AUG: "-3.65",
            SEP: "-1.32",
            OCT: "-4.18",
            NOV: "9.37",
            DEC: "6.30",
            TOTAL: "10.55"
        },
        {
            Year: '2022',
            JAN: '1.06',
            FEB: '2.3',
            MAR: '-2.34',
            APR: "-5.09",
            MAY: "-1.94",
            JUN: "7.53",
            JUL: '7.94 ',
            AUG: "-2.65",
            SEP: "-1.32",
            OCT: "-4.18",
            NOV: "8.37",
            DEC: "5.30",
            TOTAL: "12.55"
        }
    ]);

    // Column Definitions: Defines & controls grid columns.
    const [colDefs, setColDefs] = useState([
        {
            field: 'Year',
            headerName: 'Year',
            cellStyle: {
                fontWeight: "bold"
            }
        },
        {
            field: 'JAN',
            headerName: 'JAN',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }
        },
        {
            field: 'FEB',
            headerName: 'FEB',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }
        },
        {
            field: 'MAR',
            headerName: 'MAR',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }
        },
        {
            field: 'APR',
            headerName: 'APR',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }
        },
        {
            field: 'MAY',
            headerName: 'MAY',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }
        },
        {
            field: 'JUN',
            headerName: 'JUN',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }

        },
        {
            field: 'JUL',
            headerName: 'JUL',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }
        },
        {
            field: 'AUG',
            headerName: 'AUG',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }
        },
        {
            field: 'SEP',
            headerName: 'SEP',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }

        },
        {
            field: 'OCT',
            headerName: 'OCT',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }
        },
        {
            field: 'NOV',
            headerName: 'NOV',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }
        },
        {
            field: 'DEC',
            headerName: 'DEC',
            cellStyle: function (params) {
                if (params.value > 0) { //mark values greater than 0 green
                    return { color: ColorsgreenNumber };
                } else if (params.value < 0) { //mark values less than 0 red
                    return { color: Colors.redNumber };
                }
            }
        },
        {
            field: 'TOTAL',
            headerName: 'TOTAL',
            cellStyle: {
                fontWeight: "bold",
                cellStyle: function (params) {
                    if (params.value > 0) { //mark values greater than 0 green
                        return { color: ColorsgreenNumber };
                    } else if (params.value < 0) { //mark values less than 0 red
                        return { color: Colors.redNumber };
                    }
                }
            }
        },
    ]);

    function onRowClicked(params) {
        // if (params.node.data.IS_US_ONLINE !== 'Y') {
        
        var arr = [];
        if (params.node.data) {

            // if (!(params.node.data.hasOwnProperty("Year") || params.node.data.hasOwnProperty("TOTAL"))) {
            // arr.push()
            // setRowSelected([80.9, Math.random(), 5.9, -0.42, -12.6, -18.1, -18.2, -14.16, -11.1, -6.09, 0.34, Math.random()]);
            // }
            setRowSelected([params.node.data.JAN !== '' ? params.node.data.JAN : 0,
            params.node.data.FEB !== '' ? params.node.data.FEB : 0,
            params.node.data.MAR !== '' ? params.node.data.MAR : 0,
            params.node.data.APR !== '' ? params.node.data.APR : 0,
            params.node.data.MAY !== '' ? params.node.data.MAY : 0,
            params.node.data.JUN !== '' ? params.node.data.JUN : 0,
            params.node.data.JUL !== '' ? params.node.data.JUL : 0,
            params.node.data.AUG !== '' ? params.node.data.AUG : 0,
            params.node.data.SEP !== '' ? params.node.data.SEP : 0,
            params.node.data.OCT !== '' ? params.node.data.OCT : 0,
            params.node.data.NOV !== '' ? params.node.data.NOV : 0,
            params.node.data.DEC !== '' ? params.node.data.DEC : 0]
            );

        }
        // if (params.node.data.Symbol) {
        // }
    }
    var dir = "ltr";
    var leftLocalized = "left";
    var ml3Localized = "ml-3";
    var ml2Localized = "ml-2";
    var mr2Localized = "mr-2";
    var enableRtl = false;

    if (i18n.language === "ar") {
        dir = "rtl";
        leftLocalized = "right";
        ml3Localized = "mr-3";
        ml2Localized = "mr-2";
        mr2Localized = "ml-2";
        enableRtl = true;
    }

    
    let agGridClass = props.isDarkMode.isDarkMode ? "ag-theme-alpine-dark": "ag-theme-alpine" ;

    return (
        <div style={{ width: "100%" }}>
            <HeaderTitle title="Performance" dir={dir} />

            <PerformanceChart rowSelected={rowSelected} />
            <div className="custom-scrollable display-vertically" style={{ width: "100%", height: "30%" }}>
                <div className="main-grid" dir={dir} style={{ width: "100%", height: "185px" }}>
                    <div className={agGridClass} style={{
                        width: "100%",
                        height: "100%",
                        overflow: "hidden"
                    }}>
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={colDefs}
                            defaultColDef={defaultColDef}
                            rowHeight={rowHeight}
                            enableRtl={enableRtl}
                            enableBrowserTooltips={true}
                            onRowClicked={onRowClicked}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Performance
